export default {
  home: '/',
  wizard: '/',
  wizardDropAPin: '/',
  wizardMobile: '/',
  wizardDropAPinMobile: '/',
  error: '/error',
  confirmation: '/',
  recommendationInProgress: '/',
  confirmationUpdateContact: '/',
  // basename is /recommendation (set via PUBLIC_URL), so this route
  // resolves to /recommendation/:recommendation_data in the browser.
  recommendation: '/:recommendation_data',
  onboarding: '/',
  ddgProdUrl: 'https://seedselector.syngenta.com',
};
